import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { LEGACY_BASE } from '@core/routing/app-routes.enum';

export const appRoutes: Routes = [
  // ── the redesign's OWN former mount (`/v2/...`) → the same page at the root ──
  // The redesign used to live under `/v2`, and that prefix is still baked into data we
  // do not control: the backend's `NOTIFICATIONS_WEB_DEFAULT_PATH` and
  // `config/notifications.deep_links` templates author `/v2/notifications`, `/v2/home`,
  // `/v2/care/…`, and every web push ALREADY DELIVERED to a device carries such a link.
  // Those are BROWSER navigations, so `stripLegacyBase` (which only normalises links
  // handed to the in-app resolvers) cannot help them — without this they would land on
  // the branded 404.
  //
  // A function redirect rebuilds the root-based url from the matched segments and
  // carries the query string and fragment across explicitly, so a callback's params
  // survive the hop.
  {
    path: LEGACY_BASE,
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/' },
      {
        path: '**',
        redirectTo: (route) => {
          const path = route.url.map((s) => s.path).join('/');
          return inject(Router).createUrlTree(path ? [`/${path}`] : ['/'], {
            queryParams: route.queryParams,
            fragment: route.fragment ?? undefined,
          });
        },
      },
    ],
  },

  // ── the PRIMARY application (the redesign) owns the application ROOT ──────
  // Mounted at `''`, so `/` → `/home`, and every page is a top-level segment
  // (`/home`, `/care`, `/khoyek`, `/community`, `/profile`, `/subscription`,
  // `/sign-in`, `/onboarding`, `/notifications`, `/payments/status`).
  //
  // It also owns the app-level `**` catch-all (inside `PRIMARY_ROUTES`), which is why this
  // entry MUST BE LAST: nothing registered after it can ever match.
  {
    path: '',
    loadChildren: () =>
      import('./primary.routes').then(m => m.PRIMARY_ROUTES)
  },
];
